"use strict";

exports.__esModule = true;
exports.TabFields = TabFields;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields for TabElement.
 */
function TabFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "TabFields.title.label",
      defaultMessage: "Tab Title"
    }),
    helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "TabFields.title.helperText",
      defaultMessage: "The title to show for this tab."
    })
  }, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
    value: element.props.title || "",
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "title", e.target.value);
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "TabFields.rowCount.label",
      defaultMessage: "Rows"
    }),
    helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "TabFields.rowCount.helperText",
      defaultMessage: "The number of horizontal rows."
    })
  }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
    labelRenderer: false,
    min: 3,
    max: 48,
    value: element.props.rowCount || 12,
    onChange: function onChange(value) {
      return elementEditor.setProp(path, "rowCount", value);
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "TabFields.columnCount.label",
      defaultMessage: "Columns"
    }),
    helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "TabFields.columnCount.helperText",
      defaultMessage: "The number of vertical columns."
    })
  }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
    labelRenderer: false,
    min: 3,
    max: 48,
    value: element.props.columnCount || 12,
    onChange: function onChange(value) {
      return elementEditor.setProp(path, "columnCount", value);
    }
  })));
}